enum Language {
  ru = 'ru',
  en = 'en',
  uz = 'uz',
}

export { Language }
